import { render, staticRenderFns } from "./ParteList.vue?vue&type=template&id=6e8121dc&"
import script from "./ParteList.vue?vue&type=script&lang=js&"
export * from "./ParteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports